var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.14062H11V4.14062C11 3.34498 10.6839 2.58191 10.1213 2.0193C9.55871 1.4567 8.79565 1.14063 8 1.14062C7.20435 1.14063 6.44129 1.4567 5.87868 2.0193C5.31607 2.58191 5 3.34498 5 4.14062V7.14062H4C3.73478 7.14062 3.48043 7.24598 3.29289 7.43352C3.10536 7.62105 3 7.87541 3 8.14062V14.1406C3 14.4058 3.10536 14.6602 3.29289 14.8477C3.48043 15.0353 3.73478 15.1406 4 15.1406H12C12.2652 15.1406 12.5196 15.0353 12.7071 14.8477C12.8946 14.6602 13 14.4058 13 14.1406V8.14062C13 7.87541 12.8946 7.62105 12.7071 7.43352C12.5196 7.24598 12.2652 7.14062 12 7.14062ZM6 4.14062C6 3.61019 6.21071 3.10148 6.58579 2.72641C6.96086 2.35134 7.46957 2.14063 8 2.14062C8.53043 2.14063 9.03914 2.35134 9.41421 2.72641C9.78929 3.10148 10 3.61019 10 4.14062V7.14062H6V4.14062ZM12 14.1406H4V8.14062H12V14.1406Z",
    fill: "#585960"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocked);
export default __webpack_public_path__ + "static/media/ic-locked.ead12c6662611f8bb05f366c2fae0222.svg";
export { ForwardRef as ReactComponent };